import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'
import Heading from 'components/Luxkit/Typography/Heading'
import React from 'react'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import { rem } from 'polished'
import styled from 'styled-components'
import CategoryTile from 'components/Luxkit/CategoryTile'
import { mediaQueryUp } from 'components/utils/breakpoint'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Label from 'components/Luxkit/Label'

const EpisodeCarouselContainer = styled(LayoutContainer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

const StyledCategoryTile = styled(CategoryTile)`
  width: ${rem(180)};

  ${mediaQueryUp.desktop} {
    width: unset;
  }
`

interface Props {
  leTVEpisodes: App.MarketingLeTVEpisode[]
}

const EpisodeCarousel = ({ leTVEpisodes }: Props) => {
  return (
    <EpisodeCarouselContainer>
      <VerticalSpacer gap={20}>
        <Heading variant="heading3">Discover more episodes</Heading>
        <CardCarousel pageSize={6}>
          {leTVEpisodes.map((episode) => (<>
            {
              episode.isLive && <StyledCategoryTile
                key={episode.header}
                heading={episode.header}
                subHeading={`Episode ${episode.episode}`}
                align="top"
                callToAction="View"
                to={`/tv/season-6/episode-${episode.episode}`}
                image={{ id: episode.carouselImageId.id, title: episode.header }}
              />
            }
            {
              !episode.isLive && <StyledCategoryTile
                key={episode.header}
                heading={episode.header}
                subHeading={<Label kind="tertiary" variant="ghost">Coming soon</Label>}
                align="top"
                image={{ id: episode.darkCarouselImageId.id, title: episode.header }}
              />
            }
          </>))}
        </CardCarousel>
      </VerticalSpacer>
    </EpisodeCarouselContainer>
  )
}

export default EpisodeCarousel
